import { forwardRef } from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export function withErrorBoundary(WrappedComponent, errorBoundaryProps) {
  const ErrorBoundaryWrapper = /*#__PURE__*/forwardRef((props, ref) => {
    return /*#__PURE__*/_jsx(ErrorBoundary, Object.assign({}, errorBoundaryProps, {
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
        ref: ref
      }))
    }));
  });
  return ErrorBoundaryWrapper;
}
export default withErrorBoundary;